class FamiliasTemp {
    constructor(
        {
            cpf_requerente = null,
            nome_completo = null,
            nome_mae = null,
            data_nascimento = null,
            cep_endereco = null,
            tipo_logradouro = null,
            logradouro = null,
            numero_logradouro = null,
            complemento_logradouro = null,
            bairro = null,
            municipio = 'BELO HORIZONTE',
            sexo = null,
            tipo_documento = null,
            numero_documento = null,
            orgao_emissor = null,
            uf_orgao_emissor = null,
            serie_documento = null,
            pais_emissao = null,
            data_emissao = null,
            data_validade = null,      
            usuario_inclusao = null, 
            data_registro_inclusao = null, 
            usuario_alteracao = null, 
            data_registro_alteracao = null,
            familia_id = null,
            endereco = null,
        } = {}
    ) {
        this.cpf_requerente = cpf_requerente,  
        this.nome_completo = nome_completo,
        this.nome_mae = nome_mae,
        this.data_nascimento = data_nascimento,
        this.cep_endereco = cep_endereco,
        this.tipo_logradouro = tipo_logradouro,
        this.logradouro = logradouro,
        this.numero_logradouro = numero_logradouro,
        this.complemento_logradouro = complemento_logradouro,
        this.bairro = bairro,
        this.municipio = municipio,
        this.sexo = sexo,
        this.tipo_documento = tipo_documento,
        this.numero_documento = numero_documento,
        this.orgao_emissor = orgao_emissor,
        this.uf_orgao_emissor = uf_orgao_emissor,
        this.serie_documento = serie_documento,
        this.pais_emissao = pais_emissao,
        this.data_emissao = data_emissao,
        this.data_validade = data_validade,      
        this.usuario_inclusao = usuario_inclusao, 
        this.data_registro_inclusao = data_registro_inclusao, 
        this.usuario_alteracao = usuario_alteracao, 
        this.data_registro_alteracao = data_registro_alteracao,
        this.familia_id = familia_id,
        this.endereco = endereco
    }
}

export default FamiliasTemp;